import { useState } from "react";
import { ThreeDotsVertical } from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import FormButton from "../../Components/Buttons/FormButton";
import InputFieldAndDropdown from "../../Components/FormTag/InputFieldAndDropdown";
import InputFiled from "../../Components/FormTag/InputFiled";
import { measurementList } from "../../Data/dropdownDataList";
import {
  ALPHANUM_REGEX,
  ALPHANUM_SPACE_REGEX,
  NUMBER_REGEX,
} from "../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
import { PackageType } from "./model/Client.type"; 

interface ClientPackageTypeProps {
  handleNext: () => void;
}
export default function ClientPackageType(props: ClientPackageTypeProps) {
  const [errMsg, setErrMsg] = useState("");
  const [isShowErr, setShowErr] = useState(false);
  const [hideErrMsgTimeout, setHideErrMsgTimeout] =
    useState<NodeJS.Timeout | null>(null);
  const navigation = useNavigate();
  const { handleNext } = props;
  const [packageData, setpackageData] = useState<PackageType>(
    new PackageType()
  );
  const [packageDataList, setpackageDataList] = useState<PackageType[]>([]);
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    control,
    getValues,
    watch,
    formState: { errors },
  } = useForm<PackageType>({
    defaultValues: packageData,
  });
  const addPackageTypeData: SubmitHandler<PackageType> = (data) => {
    let length = data.length !== "" ? data.length : "0";
    let height = data.height !== "" ? data.height : "0";
    let width = data.width !== "" ? data.width : "0";
    const totalVolume =
      parseFloat(length) + parseFloat(height) + parseFloat(width);
    data.packageVolume = totalVolume > 0 ? totalVolume.toString() : "0";
    setpackageDataList((acc) => [...acc, data]);
    reset(new PackageType());
  };
  const watchLength = watch("length");
  const watchWidth = watch("width");
  const watchHeight = watch("height");
  const handelCancelBtn = () => {
    navigation("/account/client/overview/grid-view");
  };
  const handelNextBtn = () => {
    if (packageDataList.length === 0) {
      setShowErr(true);
      setErrMsg("Enter package code");
      const timeout = setTimeout(() => {
        setShowErr(false);
        setErrMsg("");
      }, 2000);

      setHideErrMsgTimeout(timeout);
    } else {
      setShowErr(false);
      handleNext();
    }
  };

  const handelUnitValue = (value: string) => {
    setValue("lengthMeasurement", value);
    setValue("widthMeasurement", value);
    setValue("heightMeasurement", value);
  };
  return (
    <>
      <div className="my-2 bg-white rounded py-4">
        {isShowErr && (
          <div
            className="alert alert-danger text-center position-fixed alert-on-top"
            role="alert"
          >
            {errMsg}
          </div>
        )}
        <div className="d-flex ps-4 justify-content-between">
          <div className="col-4 px-2">
            <label className="fw-medium">Package Code *</label>
            <div className="mt-1">
              <InputFiled
                tabIndex={1}
                autoFocus
                name="packCode"
                register={register}
                type="text"
                className="form-control"
                required={true}
                errors={errors.packCode}
                pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                placeholder="Enter package code"
              />
            </div>
          </div>
          <div className="col-4 px-2">
            <label className="fw-medium">Description </label>
            <div className="mt-1">
              <InputFiled
                tabIndex={2}
                name="desc"
                register={register}
                type="text"
                className="form-control"
                placeholder="Enter Description"
                errors={errors.desc}
                pattern={{
                  type: ALPHANUM_SPACE_REGEX,
                  message: PATTERN_ERR_MSG,
                }}
              />
            </div>
          </div>
          <div className="mt-1">
            <FormButton
              tabIndex={9}
              className="sph-btn me-4 mt-4 "
              handleClick={handleSubmit(addPackageTypeData)}
            >
              Add
            </FormButton>
          </div>
        </div>
        <div className="d-flex ps-4 justify-content-between padding-right-24 mt-4">
          <div className="col-4 px-2 vw-20 me-5">
            <label className="w-100">
              <div className="d-flex justify-content-between">
                <div className="col-8 fw-medium">Length</div>
                <div className="col-4 fw-medium">Unit</div>
              </div>
            </label>
            <div className="mt-1 d-flex col-12">
              <InputFieldAndDropdown
                inputName="length"
                register={register}
                className="form-control br-radius-0"
                type="text"
                placeholder="Enter Length"
                errors={errors.length}
                pattern={{ type: NUMBER_REGEX, message: PATTERN_ERR_MSG }}
                inputDivClassName="input-width col-8"
                inputTabIndex={3}
                control={control}
                dropdownName="lengthMeasurement"
                dropPlaceholder="Select"
                optionList={measurementList}
                dropdownClassName="form-control p-0 bl-radius-0 input-selection-dropdown"
                dropdownRequired={!!watchLength}
                dropdownErrors={errors.lengthMeasurement}
                dropdownDivClassName="max-width col-4"
                dropdownTabIndex={4}
                dorpdownOnChange={(data) => {
                  if (data) {
                    handelUnitValue(data);
                  }
                }}
              />
            </div>
          </div>
          <div className="col-4 px-2 vw-20 me-5">
            <label className="w-100">
              <div className="d-flex justify-content-between">
                <div className="col-8 fw-medium">Width</div>
                <div className="col-4 fw-medium">Unit</div>
              </div>
            </label>
            <div className="mt-1 d-flex col-12">
              <InputFieldAndDropdown
                inputName="width"
                register={register}
                className="form-control br-radius-0"
                type="text"
                placeholder="Enter Width"
                errors={errors.width}
                pattern={{ type: NUMBER_REGEX, message: PATTERN_ERR_MSG }}
                inputTabIndex={5}
                inputDivClassName="input-width col-8 "
                control={control}
                dropdownName="widthMeasurement"
                optionList={measurementList}
                dropdownClassName="form-control p-0 bl-radius-0 input-selection-dropdown"
                dropPlaceholder="Select"
                dropdownRequired={!!watchWidth}
                dropdownErrors={errors.widthMeasurement}
                dropdownDivClassName="max-width col-4"
                dropdownTabIndex={6}
                dorpdownOnChange={(data) => {
                  if (data) {
                    handelUnitValue(data);
                  }
                }}
              />
            </div>
          </div>
          <div className="col-4 px-2 vw-20 me-5">
            <label className="w-100">
              <div className="d-flex justify-content-between">
                <div className="col-8 fw-medium">Height</div>
                <div className="col-4 fw-medium">Unit</div>
              </div>
            </label>
            <div className="mt-1 d-flex col-12">
              <InputFieldAndDropdown
                inputName="height"
                register={register}
                className="form-control br-radius-0"
                type="text"
                placeholder="Enter Height"
                errors={errors.height}
                pattern={{ type: NUMBER_REGEX, message: PATTERN_ERR_MSG }}
                inputDivClassName="input-width col-8"
                inputTabIndex={7}
                control={control}
                dropdownName="heightMeasurement"
                optionList={measurementList}
                dropPlaceholder="Select"
                dropdownClassName="form-control p-0 bl-radius-0 input-selection-dropdown"
                dropdownRequired={!!watchHeight}
                dropdownErrors={errors.heightMeasurement}
                dropdownDivClassName="max-width col-4"
                dropdownTabIndex={8}
                dorpdownOnChange={(data) => {
                  if (data) {
                    handelUnitValue(data);
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex flex-column min-height-19">
        {packageDataList.length > 0 && (
          <div className="my-2 bg-white rounded p-4">
            <table className="table transferDetailsTable table-striped sph-table table-non-border">
              <thead>
                <tr className="text-center">
                  <th scope="col">Package Code</th>
                  <th scope="col">Package Volume</th>
                  <th scope="col">Description</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                {packageDataList.map((item, index) => (
                  <tr className="text-center" key={index}>
                    <td>{item.packCode}</td>
                    <td>
                      {item.packageVolume} {item.lengthMeasurement}
                    </td>
                    <td>{item.desc}</td>
                    <td>
                      <span className="w-50 badge text-bg-light border border-2 px-3 border-info-subtle cursor-pointer">
                        Active
                      </span>
                    </td>
                    <td>
                      <span
                        className="cursor-pointer dropdown-toggle action-menu"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <ThreeDotsVertical />
                      </span>
                      <ul className="dropdown-menu action-items">
                        <li className="cursor-pointer ms-3 mb-1">Edit</li>
                        <li className="cursor-pointer ms-3 mb-1">Inactive</li>
                        <li className="cursor-pointer ms-3 mb-1">Delete</li>
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <div className="my-2 bg-white rounded py-3 mt-auto">
          <div className="d-flex flex-row-reverse">
            <FormButton
              className="sph-btn me-4"
              handleClick={handelNextBtn}
              tabIndex={10}
            >
              Next
            </FormButton>
            <FormButton
              tabIndex={11}
              className="sph-btn sph-shift me-4"
              handleClick={handelCancelBtn}
            >
              Cancel
            </FormButton>
          </div>
        </div>
      </div>
    </>
  );
}
